/* mobile-core/src/notifications */

// import $ from 'jquery';
import core from './payment/common/lib/core.js';

const $ = jQuery;

let $globalNotificationsContainer = $('.global-notification');
const typesArray = ['success', 'fail'];

// Effects are not implemented/used for MVP
const validEffects = ['confetti', 'rain'];

const validColors = ['red', 'green', 'yellow'];
const iconsForConfirmationModal = ['default-success', 'default-failure', 'forgotten-password', 'has-documents', 'empty-documents'];
const timerForMessageAutoHide = 20000;
const elements = {};

let storedInfo;

function hideNotification() {
	const $notification = $globalNotificationsContainer.find('.notification-wrap');
	$notification.removeClass('notification-wrap--open').addClass('notification-wrap--close');
	$notification.find('.notification-wrap__error-text-msg').text('');
	$globalNotificationsContainer.removeClass('global-notification--is-open');
}

function shouldHideGlobalNotification() {
	const notificationArray = document.querySelectorAll('.notify--is-open');
	const notifyArray = [];
	for (let i = 0; i < notificationArray.length; i += 1) {
		if (notificationArray[i].classList.contains('u-hide') === false) {
			notifyArray.push(notificationArray[i]);
		}
	}
	return (notifyArray.length < 1);
}


function closeNotifyWrapper($notifyWrapper) {
	// TODO clean messages
	$($notifyWrapper).removeClass('notify--is-open');
	if (shouldHideGlobalNotification()) {
		$globalNotificationsContainer.removeClass('global-notification--is-open');
	}
}

function showNotification(message, color, autoHide, customTimer) {
	const $notification = $globalNotificationsContainer.find('.notification-wrap');
	const notificationColor = (color && $.inArray(color, validColors) >= 0) ? color : 'yellow';

	document.getElementsByClassName('notification-wrap__error-text-msg')[0].innerHTML = message;

	$globalNotificationsContainer.addClass('global-notification--is-open');
	$notification.removeClass('notification-wrap--close red green yellow').addClass(`notification-wrap--open ${notificationColor}`);

	// add click handler to close the notification
	$notification.find('.icon-close').on('click', (event) => {
		event.preventDefault();
		event.stopPropagation();
		hideNotification();
	});

	if (autoHide) {
		setTimeout(() => {
			hideNotification();
		}, (customTimer || timerForMessageAutoHide));
	}
}

function showInformationMessage(type, titleText, messageText, effect, time, closeCallback) {
	const $informationWrapper = $globalNotificationsContainer.find('.js-information-message');
	const textWrapper = $informationWrapper.find('.notify__text-wrapper');
	const titleElement = textWrapper.find('.js-notify__main-title');
	const messageElement = textWrapper.find('.js-notify__p');
	const confirmationEffect = (effect && $.inArray(effect, validEffects) >= 0) ? effect : '';
	const typeSelected = (type && $.inArray(type, typesArray) >= 0) ? type : 'success';
	const $closeButton = $informationWrapper.find('.icon-close');
	const timeToShow = (time || timerForMessageAutoHide);
	const $successIcon = $informationWrapper.find('.js-icon-success');
	const $failIcon = $informationWrapper.find('.js-icon-fail');

	if (typeSelected === 'success') {
		$successIcon.removeClass('u-hide');
		$failIcon.addClass('u-hide');
	} else {
		$successIcon.addClass('u-hide');
		$failIcon.removeClass('u-hide');
	}

	titleElement.text(titleText);
	messageElement.text(messageText);

	$globalNotificationsContainer.addClass('global-notification--is-open');
	$informationWrapper.addClass(`notify--is-open${confirmationEffect}`);

	// enter negative time to disable auto-hide
	// Always enable close button
	if (timeToShow > 0) {
		// $closeButton.addClass('u-hide');
		setTimeout(() => {
			closeNotifyWrapper($informationWrapper);
			$(titleElement, messageElement).text('');
		}, timeToShow);
	} // else {
	$closeButton.removeClass('u-hide');
	$closeButton.off('click');

	if (closeCallback) {
		$closeButton.click(() => {
			closeCallback();
		});
	} else {
		$closeButton.click(() => {
			closeNotifyWrapper($informationWrapper);
			$(titleElement, messageElement).text('');
		});
	}
	// }
}

function closeConfirmationMessage() {
	core.removeClass(elements.confirmationWrapper, 'notify--is-open');
	if (shouldHideGlobalNotification()) {
		core.removeClass(elements.wrap, 'global-notification--is-open');
	}
	elements.icon.classList.add('u-hide');
	elements.closeButtonElement.classList.add('u-hide');
	elements.buttonElement.innerHTML = '';
	elements.closeButtonElement.innerHTML = '';
	elements.mainTitle.innerHTML = '';
	elements.mainText.innerHTML = '';
}
function showConfirmationMessage(p) {
	const { iconIdentifier } = p;
	const { titleText } = p;
	const { messageText } = p;
	const { buttonText } = p;
	const { confirmCallback } = p;
	const { closeButtonText } = p;
	const { callbacks } = p;
	const { globalWrap } = p;
	const confirmationCallback = confirmCallback;
	const iconSelected = (iconIdentifier && $.inArray(iconIdentifier, iconsForConfirmationModal) >= 0) ? iconIdentifier : 'default-success';
	elements.confirmationWrapper = elements.wrap.querySelector('.js-confirm-modal');
	elements.iconWrapper = elements.confirmationWrapper.querySelector('.js-notify__icon-wrapper');
	elements.icon = elements.iconWrapper.querySelector(`.${iconSelected}`);
	elements.mainTitle = elements.confirmationWrapper.querySelector('.js-notify__main-title');
	elements.mainText = elements.confirmationWrapper.querySelector('.js-notify__main-text');
	elements.buttonWrapper = elements.confirmationWrapper.querySelector('.js-notify__button-wrapper');
	elements.buttonElement = elements.buttonWrapper.querySelector('.js-button');
	elements.closeButtonElement = elements.buttonWrapper.querySelector('.js-close-button');
	elements.buttonElement.innerHTML = (buttonText || '');
	elements.closeButtonElement.innerHTML = (closeButtonText || '');
	elements.mainTitle.innerHTML = (titleText || '');
	elements.mainText.innerHTML = (messageText || '');

	function showIcon() {
		core.addClass(elements.icon, 'u-show');
		core.removeClass(elements.icon, 'u-hide');
	}

	function openWrappers() {
		core.addClass(elements.wrap, 'global-notification--is-open');
		core.addClass(elements.confirmationWrapper, 'notify--is-open');
	}

	function clickAcceptHandler() {
		if (confirmationCallback) {
			confirmationCallback();
		}
		closeConfirmationMessage(globalWrap);
	}

	function clickCancelHandler() {
		if (callbacks && callbacks.closeCallback) {
			callbacks.closeCallback();
		}
		closeConfirmationMessage(globalWrap);
	}

	function showCloseButton() {
		if (closeButtonText) {
			elements.closeButtonElement.classList.remove('u-hide');
		}
	}

	elements.buttonElement.addEventListener('click', clickAcceptHandler);
	elements.closeButtonElement.addEventListener('click', clickCancelHandler);
	showIcon();
	showCloseButton();
	openWrappers();
	if (callbacks && callbacks.viewReadyCallback) {
		callbacks.viewReadyCallback();
	}
}

function showBinaryQuestion(title, confirmButtonText, rejectButtonText, confirmCallback, rejectCallback, text) {
	const $binaryQuestionWrapper = $globalNotificationsContainer.find('.js-binary-question');
	const titleWrapper = $binaryQuestionWrapper.find('.js-title');
	const textWrapper = $binaryQuestionWrapper.find('.js-');
	const confirmButton = $binaryQuestionWrapper.find('.binary-question__yes');
	const rejectButton = $binaryQuestionWrapper.find('.binary-question__no');
	const confirmationCallback = confirmCallback || function empty() {};
	const rejectionCallback = rejectCallback || function empty() {};

	if (confirmButtonText) {
		confirmButton.text(confirmButtonText);
	}
	if (rejectButtonText) {
		rejectButton.text(rejectButtonText);
	}

	confirmButton.off();

	confirmButton.on('click', (e) => {
		e.preventDefault();
		confirmationCallback();
		closeNotifyWrapper($binaryQuestionWrapper);
	});

	rejectButton.off();

	rejectButton.on('click', (e) => {
		e.preventDefault();
		rejectionCallback();
		closeNotifyWrapper($binaryQuestionWrapper);
	});

	titleWrapper.text(title);
	textWrapper.text(text);

	$globalNotificationsContainer.addClass('global-notification--is-open');
	$binaryQuestionWrapper.addClass('notify--is-open');
}

function init() {
	const globalContainer = document.querySelector('.global-notification');
	$globalNotificationsContainer = ($globalNotificationsContainer || $('.global-notification'));
	elements.wrap = globalContainer;
	return globalContainer;
	/* this wrapper is put into below the #container div and in one occurence per casino, shop and ... */
}

// Use the exported api instead // Sunny
// window.showNotification = showNotification;
window.showNotification = function printToConsole(message, color, autoHide, customTimer) {
	console.error('notifications: do not use this module from the window object. Use the exported api instead.');
	showNotification(message, color, autoHide, customTimer);
};

export default {
	showInformationMessage(type, titleText, messageText, effect, time, closeCallback) {
		// TODO: adding an intermediate layer to separate implementation from api and place readability to the export.
		init();
		showInformationMessage(type, titleText, messageText, effect, time, closeCallback);
	},
	showConfirmationMessage(iconIdentifier, titleText, messageText, buttonText, confirmCallback, closeButtonText, callbacks) {
		// TODO: adding an intermediate layer to separate implementation from api and place readability to the export.
		const globalWrap = init();
		// showConfirmationMessage(iconIdentifier, titleText, messageText, buttonText, confirmCallback, closeButtonText, callbacks);
		showConfirmationMessage({
			iconIdentifier,
			titleText,
			messageText,
			buttonText,
			confirmCallback,
			closeButtonText,
			callbacks,
			globalWrap
		});
	},
	showBinaryQuestion(messageText, confirmButtonText, rejectButtonText, confirmCallback, rejectCallback) {
		// TODO: adding an intermediate layer to separate implementation from api and place readability to the export.
		init();
		showBinaryQuestion(messageText, confirmButtonText, rejectButtonText, confirmCallback, rejectCallback);
	},
	showNotification(message, color, autoHide, customTimer) {
		// TODO: adding an intermediate layer to separate implementation from api and place readability to the export.
		init();
		showNotification(message, color, autoHide, customTimer);
	},
	hideNotification() {
		// TODO: adding an intermediate layer to separate implementation from api and place readability to the export.
		init();
		hideNotification();
	},
	closeNotifyWrapper(notifyWrapper) {
		// TODO: adding an intermediate layer to separate implementation from api and place readability to the export.
		init();
		closeNotifyWrapper(notifyWrapper);
	},
	storeInfo(p) {
		/* copy of text in 'signup-validation.js' :
		 the notification is not directly controlled from here, since it gets overly complex to keep track of the
		mix of timers, global overlaying elements, navigation routing, notifications-module used by many modules and asynchrononus calls.
		The notifications module is therefore extended (temporarily) to keep the information and access it later.
		For example may this module be appended with a check to the 'storedInfo' object, to see if some data may be displayed.
		/Sunny jan 2017*/
		// {'posting':'signup-validation','type':informationmessage,success:true, message:msg}
		storedInfo = p;
	},
	hideConfirmationMessage: closeConfirmationMessage
};



// WEBPACK FOOTER //
// ./mobile-core/src/notifications.js